import Vue from 'vue';
import BModalUI from '../../components/modals/BModalUI'

Vue.component('BModalUI', BModalUI)
